export default "__VITE_ASSET__IjJ0T7YX__"